export enum IndexedDBKeysDataType {
  STRING,
  INTEGER,
  OBJECT,
  ARRAY,
  BOOLEAN,
  ANY
}
